import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { Url } from '@wix/da-url';
import DaDreamupLogoAndText from '@wix/da-ds/pkg/DaDreamupLogoAndText';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import s from './DreamupInfo.scss';
function getHighlightedCallToActionText(t, isMobile, hasCoreMembership) {
    if (hasCoreMembership && isMobile) {
        return t('deviation.details.dreamup.callToAction.link.text.core.mobile');
    } else if (hasCoreMembership && !isMobile) {
        return t('deviation.details.dreamup.callToAction.link.text.core.desktop');
    } else if (isMobile) {
        return t('deviation.details.dreamup.callToAction.link.text.free.mobile');
    } else {
        return t('deviation.details.dreamup.callToAction.link.text.free.desktop');
    }
}
const CallToActionBlock = ()=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const { hasCoreMembership } = useContext(SessionContext);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: s['call-to-action-block'],
        href: Url.dreamupLink()
    }, /*#__PURE__*/ React.createElement(DaDreamupLogoAndText, {
        className: s['logo']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['call-to-action-text-stack']
    }, !isMobile && /*#__PURE__*/ React.createElement("p", {
        className: s['call-to-action-forward-copy']
    }, t('deviation.details.dreamup.callToAction.forwardCopy')), /*#__PURE__*/ React.createElement("span", {
        className: s['call-to-action-highlighted-text']
    }, getHighlightedCallToActionText(t, isMobile, hasCoreMembership))));
};
const DreamupInfo = ({ prompt, className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("p", {
        className: s['prompt']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['prompt-preface']
    }, t('deviation.details.dreamup.promptPreface'), ":"), prompt), /*#__PURE__*/ React.createElement("div", {
        className: s['call-to-action-and-preface']
    }, /*#__PURE__*/ React.createElement("p", {
        className: s['call-to-action-preface']
    }, t('deviation.details.dreamup.callToAction.preface')), /*#__PURE__*/ React.createElement(CallToActionBlock, null)));
};
DreamupInfo.displayName = 'DreamupInfo';
export default DreamupInfo;
